import fs from 'node:fs'
import { filesDir } from './files-dir.js'

export function hasSnapshotFiles(cwd: string, scope: string): boolean {
  return fs.existsSync(filesDir(cwd, scope))
}
